module.exports = __webpack_public_path__ + "img/CAR.32a287b1.jpg";